import { isUndefined } from 'lodash'
import { makeAutoObservable, observable } from 'mobx'

import { defaultMobxCacheMaxAge, type RootStore } from 'stores/RootStore'
import { makePersistable } from 'mobx-persist-store'

export class LeftSidebarStore {
  rootStore: RootStore
  isHovered: boolean = false
  shouldAutoscroll: boolean = false
  sidebarWidth: number = 190
  isResizing: boolean = false
  startOffset: number = 0
  initialWidth: number = 256

  constructor(rootStore: RootStore, shouldPersist = true) {
    this.rootStore = rootStore
    makeAutoObservable(this, {
      isHovered: observable,
      sidebarWidth: observable,
      shouldAutoscroll: observable,
      isResizing: observable,
    })

    if (shouldPersist) {
      makePersistable(this, {
        name: 'LeftSidebarStore',
        properties: ['isHovered', 'sidebarWidth', 'shouldAutoscroll', 'isResizing'],
        stringify: false,
        expireIn: defaultMobxCacheMaxAge,
      })
    }
  }

  setIsHovered(isHovered: boolean) {
    this.isHovered = isHovered
  }

  setShouldAutoscroll(shouldAutoscroll: boolean) {
    this.shouldAutoscroll = shouldAutoscroll
  }

  isHovering() {
    return this.isHovered && !this.isResizing
  }

  setResizingState({
    sidebarWidth,
    isResizing,
    startOffset,
    initialWidth,
  }: {
    sidebarWidth?: number
    isResizing?: boolean
    startOffset?: number
    initialWidth?: number
  }) {
    if (!isUndefined(sidebarWidth)) this.sidebarWidth = sidebarWidth
    if (!isUndefined(isResizing)) this.isResizing = isResizing
    if (!isUndefined(startOffset)) this.startOffset = startOffset
    if (!isUndefined(initialWidth)) this.initialWidth = initialWidth
  }
}
